const waitFor = ms =>
  new Promise(resolve => {
    setTimeout(resolve, ms)
  })

export default waitFor
